import Box from "@mui/material/Box";
import useTheme from "@mui/material/styles/useTheme";
import useMediaQuery from "@mui/material/useMediaQuery";
import { useState } from "react";
import DeviceFirmwareGrid from "./components/DeviceFirmwareGrid";
import DeviceSearchField from "./components/DeviceSearchField";
import { useDataGridSettings } from "@/components/DataGridSettingsProvider";
import { PresetSelect } from "@/components/filter/PresetSelect";
import VehicleFilterButton from "@/components/filter/VehicleFilterButton";
import { FilterStackLayout } from "@/components/layout/FilterStackLayout";
import {
  DEVICE_FIELDS_WITH_FIRMWARE,
  useDevicesBySearch,
} from "@/hooks/devices/useDevicesBySearch";
import { useDebounced } from "@/hooks/useDebounced";

// Basically a copy of the device status page with the extra of requesting uuid etc.
export default function DeviceFirmwarePage() {
  const [search, setSearch] = useState("");
  const searchDebounced = useDebounced(search, 300);
  const { showArchivedVehicles, setShowArchivedVehicles } = useDataGridSettings();
  const { data: devices = [], isLoading: loadingDevices } = useDevicesBySearch(
    searchDebounced,
    showArchivedVehicles,
    DEVICE_FIELDS_WITH_FIRMWARE,
  );

  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down(700));

  return (
    <FilterStackLayout
      isMobile={isMobile}
      filters={
        <Box
          sx={{
            display: "flex",
            flexDirection: isMobile ? "column" : "row",
            width: "100%",
            gap: 2,
          }}
        >
          <PresetSelect />
          <DeviceSearchField value={search} setValue={setSearch} />
          <VehicleFilterButton
            onFilterChange={setShowArchivedVehicles}
            showArchived={showArchivedVehicles}
          />
        </Box>
      }
      content={<DeviceFirmwareGrid devices={devices} loadingDevices={loadingDevices} />}
    />
  );
}
